export function getYoutubeId(url) {
  const regExp =
    /^(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?.*v=([^&]+).*$/;
  const match = url.match(regExp);
  const value = match ? match[1] : "";
  return value;
}